import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import styled from 'styled-components';
import { Button } from '../Controls';
import { DeckPanel, useDeckZooms } from '../DecksPage/DeckPanel';

/** Over the game, under a card or box shown full size (CardZoom's 60). */
const Sheet = styled.div`
  position: fixed;
  inset: 0;
  z-index: 50;
  overflow-y: auto;
  padding: 12px 12px 24px;
  background: var(--bg, #0c1d14);

  & > div {
    max-width: 900px;
    margin: 0 auto;
  }
`;

const Top = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
`;

/**
 * A deck opened from the deck chooser: the same view as the Decks page (its box and every card), over the game.
 * Close or Escape goes back to choosing; Escape closes a card shown full size first.
 */
const DeckSheet = ({ deck, cardsById, onClose }) => {
  const { onCard, onBox, zooms, open } = useDeckZooms();

  useEffect(() => {
    const close = (event) => event.key === 'Escape' && !open && onClose();
    window.addEventListener('keydown', close);
    return () => window.removeEventListener('keydown', close);
  }, [open, onClose]);

  return (
    <Sheet role="dialog" aria-label={deck.get('name')}>
      <div>
        <Top><Button onClick={onClose}>Close</Button></Top>
        <DeckPanel deck={deck} cardsById={cardsById} onCard={onCard} onBox={onBox} />
      </div>
      {zooms}
    </Sheet>
  );
};

DeckSheet.propTypes = {
  deck: PropTypes.instanceOf(Map).isRequired,
  cardsById: PropTypes.instanceOf(Map).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DeckSheet;
